import { useUserInfo } from '#imports'

export function useNavigationFilter() {
    const { isLoggedIn, isExisting } = useUserInfo()

    function isVisible(item: { hideWhenLoggedIn?: boolean, hideWhenNotLoggedIn?: boolean, hideWhenExisting?: boolean }) {
        if (item.hideWhenLoggedIn && isLoggedIn.value) return false
        if (item.hideWhenNotLoggedIn && !isLoggedIn.value) return false
        if (item.hideWhenExisting && isExisting.value) return false
        return true
    }

    function resolveHref(item: { href?: string, newUserHref?: string }) {
        return !isExisting.value && item.newUserHref ? item.newUserHref : item.href
    }

    return { isVisible, resolveHref }
}
